import { render, staticRenderFns } from "./HqPanelPaymentMethod.vue?vue&type=template&id=5b29af6c&scoped=true&lang=pug&"
import script from "./HqPanelPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./HqPanelPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./HqPanelPaymentMethod.vue?vue&type=style&index=0&id=5b29af6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b29af6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VMenu,VRow,VSpacer})
